import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import getLiensOrJudgementsDetail from "../searchresults/LiensJudgementsDetail";

class LiensOrJudgmentsDetails extends Component {
  componentDidMount() {}

  render() {
    const rows = [];
    if (this.props.records !== undefined && this.props.records.length > 0) {
      const exactMatchRecords = _.filter(
        this.props.records,
        (a) =>
          _.get(a, "$.matchedFilter") === "Yes" || !_.get(a, "$.matchedFilter")
      );
      if (exactMatchRecords !== undefined && exactMatchRecords.length > 0) {
        _.forEach(exactMatchRecords, (record, exactMatchIndex) => {
          rows.push(
            <Table.Row key={`Bank_Row_${exactMatchIndex}`}>
              <Table.Cell>
                {getLiensOrJudgementsDetail(
                  this.props,
                  record,
                  exactMatchIndex
                )}
              </Table.Cell>
            </Table.Row>
          );
        });
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={100}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    return (
      <Table>
        <Table.Body>
          <Table.Row className="report-sub-section-header">
            <Table.Cell colSpan={6}>
              {this.props.title} Exact Matches
            </Table.Cell>
          </Table.Row>
          {rows}
        </Table.Body>
      </Table>
    );
  }
}
export default LiensOrJudgmentsDetails;



// WEBPACK FOOTER //
// ./src/components/reports/LiensOrJudgmentsDetails.js